<template>
  <div class="__single-photo-upload">
    <div v-if="value" class="__upload-image" v-loading="isLoading">
      <el-image ref="img" :src="'/api'+value" fit="cover" :preview-src-list="['/api'+value]" />
      <div class="__image-buttons">
        <i class="el-icon-zoom-in" @click="onPreview"></i>
        <el-popconfirm title="确定删除吗？" v-if="showDel&&IsDetail==false" 
          @confirm="onDelete"
          @onConfirm="onDelete">
          <i class="el-icon-delete" slot="reference" style="margin-left:10px"></i>
        </el-popconfirm>
      </div>
    </div>
    <el-upload
      :headers="header"
      :action="uploadUrl"
      :on-success="onUploadSuccess"
      :show-file-list="false"
      :data="data"
    >
      <div class="__upload-area" v-if="!IsDetail">
        <i class="el-icon-upload2"></i>
      </div>
    </el-upload>
    <div class="t-tip" v-if="tip!=''">
      <span>{{tip}}</span>
    </div>
  </div>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    value: {
      type: String,
      default: undefined,
    },
    uploadUrl: {
      type: String,
      default: api.uploadPictureUrl,
    },
    deleteFunc: {
      type: Function,
      default: api.deletePhoto,
    },
    type: {
      type: String,
      default: undefined,
    },
    data: {
      type: Object,
      default: null,
    },
    showDel: {
      type: Boolean,
      default: true,
    },
    IsDetail: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
  },
  watch: {
    // value(nv) {
    //   this.Lvalue = nv;
    // },
  },
  data() {
    return {
      isLoading: false,
      // Lvalue: "",
    };
  },
  computed: {
    // fileList() {
    //   if (!this.Lvalue) return [];
    //   return [
    //     {
    //       url: this.Lvalue,
    //     },
    //   ];
    // },
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    onUploadSuccess(res, file, fileList) {
      // console.log(res);
      this.$emit("input", "" + res.Data);
    },
    onDelete() {
      this.$emit("input", "");
      // this.isLoading = true;
      // this.deleteFunc(this.value).then((res) => {
      //   this.isLoading = false;
      //   if (res.Code == 0) {
      //     this.$emit("input", "");
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
      // this.Lvalue = "";
      this.$emit("delLogo");
    },
    onPreview() {
      this.$refs.img.clickHandler();
    },
  },
};
</script>

<style lang="scss">
.t-tip {
  position: relative;
  width: 200px;
  span {
    left: 8px;
    bottom: 2px;
    position: absolute;
    font-size: 14px;
    color: #909399;
  }
}
.__single-photo-upload {
  display: flex;
  .__upload-area {
    border: 1px dashed #c0ccda;
    // border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    line-height: 120px;
    width: 120px;
    height: 120px;
    font-size: 32px;
    color: #8c939d;
  }
  .__upload-area:hover {
    border-color: #409eff;
  }
  .__upload-image {
    border: 1px solid #c0ccda;
    // border-radius: 6px;
    overflow: hidden;
    width: 120px;
    height: 120px;
    margin-right: 10px;
    position: relative;
    .el-image {
      width: 100%;
      height: 100%;
      // object-fit: cover;
    }
    .__image-buttons {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      opacity: 0;
      background: rgba(0, 0, 0, 0.5);
      line-height: 120px;
      color: #ffffff;
      transition: opacity 0.3s;
      text-align: center;
      i {
        font-size: 18px;
        cursor: pointer;
      }
      i + i {
        margin-left: 10px;
      }
    }
    .__image-buttons:hover {
      opacity: 1;
    }
  }
}
</style>